import { PropsWithChildren } from 'react'
import ClassNameBuilder from '../../../tools/ClassNameBuilder'

type HeadingTag = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
interface HeadingProps extends PropsWithChildren {
    className?: string
    anchor?: string
    standalone?: boolean
    size: number
}

export default function Heading({ className, anchor, size, standalone, children }: HeadingProps) {
    const onAnchorClick = anchor ? () => (location.hash = anchor) : undefined
    const classNames = new ClassNameBuilder()
        .add('heading')
        .addIf('anchor', !!anchor)
        .addIf('standalone', standalone)
        .add(className)
    const Tag = `h${size}` as HeadingTag
    return (
        <Tag id={anchor} className={classNames.toString()} onClick={onAnchorClick}>
            {children}
        </Tag>
    )
}
